class ShuttleNavSelect {
  constructor(root) {
    this.root = root;
    this.selectInner = root.querySelector('.shuttle-nav__select-inner');
    this.options = root.querySelector('.shuttle-nav__select-options');
    this.value = root.querySelector('.shuttle-nav__select-value');

    if (!this.selectInner || !this.options || !this.value) return;

    this.handleSelectInnerClick = this.handleSelectInnerClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleOptionsClick = this.handleOptionsClick.bind(this);

    this.selectInner.addEventListener('click', this.handleSelectInnerClick);
    document.addEventListener('click', this.handleDocumentClick);
    this.options.addEventListener('click', this.handleOptionsClick);
  }

  handleSelectInnerClick(e) {
    e.stopPropagation();
    this.options.classList.toggle('active');
  }

  handleDocumentClick(e) {
    if (!this.root.contains(e.target)) {
      this.options.classList.remove('active');
    }
  }

  handleOptionsClick(e) {
    const option = e.target.closest('.shuttle-nav__select-option');
    if (!option) return;
    e.stopPropagation();
    e.preventDefault();
    this.value.textContent = option.textContent;
    this.options.classList.remove('active');
    const link = option.getAttribute('data-link');
    if (link && link.startsWith('#')) {
      const anchor = link.slice(1);
      const target = document.getElementById(anchor);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.history.replaceState(null, '', link);
      }
    } else if (link) {
      window.location.href = link;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const selects = document.querySelectorAll('.shuttle-nav__select');
  selects.forEach((select) => {
    // eslint-disable-next-line no-new
    new ShuttleNavSelect(select);
  });

  document.querySelectorAll('.shuttle-nav__item[href^="#"]').forEach((link) => {
    link.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const anchor = href.slice(1);
        const target = document.getElementById(anchor);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          window.history.replaceState(null, '', href);
        }
      }
    });
  });
});
